import { render, staticRenderFns } from "./validation-editor.vue?vue&type=template&id=c8223398&scoped=true"
import script from "./validation-editor.vue?vue&type=script&lang=js"
export * from "./validation-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8223398",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8223398')) {
      api.createRecord('c8223398', component.options)
    } else {
      api.reload('c8223398', component.options)
    }
    module.hot.accept("./validation-editor.vue?vue&type=template&id=c8223398&scoped=true", function () {
      api.rerender('c8223398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/validation-editor.vue"
export default component.exports